import React, { useState } from 'react'
import { Col, Icon, Panel, Row } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import { Controller, useForm } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { doneLoading, startLoading } from '../../utils/loading'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { SaveAssessmentPrePostTestForm } from '../../redux/actions/assessment'
import RenderAssessmentForm from './RenderAssessmentForm'
import PrePostTestView from './PrePostTestView'
import pathname from '../../constants/pathname'
import ViewButton from '../../components/buttons/viewButton/ViewButton'

export default function PrePostTestWidgets({ schema, isView, isPreView, ...props }) {
  const { register, handleSubmit, errors, control, setValue, reset, clearErrors, getValues } =
    useForm()

  const [result, setResult] = useState(new Map())
  const [isShowConfim, setIsShowConfim] = useState()
  const [isLoading, setIsLoading] = useState()
  const [isSuccess, setIsSuccess] = useState()
  const [isRefash, setIsRefash] = useState()

  const handleCallSaveService = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await SaveAssessmentPrePostTestForm(request)
      if (response?.successed) {
        setIsSuccess(true)
      } else {
        notification.open('error', {
          title: response?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('PrePostTestWidgets HandleCallSaveService Error : ', e)

      notification.open('error', {
        title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSave = (data) => {
    setIsShowConfim(true)
  }

  const onSubmit = (data) => {
    console.log('data : ', data)

    let assessments = []

    result?.forEach((value, key) => {
      assessments.push({
        //id: '',
        questionId: key,
        value: value,
      })
    })

    let req = {
      id: schema.id,
      assessmentId: schema.assessmentId,
      projectCode: data.projectCode,
      email: data.email,
      name: data.name,
      assessments: assessments,
    }

    handleCallSaveService(req)
    setIsShowConfim(false)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      {!isRefash && (
        <>
          {isSuccess ? (
            <Panel bordered style={{ marginTop: 10 }} shaded>
              <div style={{ textAlign: 'center' }}>
                <Row style={{ paddingTop: 20 }}>
                  <Icon icon="check-circle" size="3x" style={{ color: '#2da888' }} />
                </Row>
                <Row>
                  <label className="rs-panel-heading">
                    <h4>{SAVE_SUCCESS_MSG}</h4>
                  </label>
                </Row>
                <Row style={{ marginTop: 20 }}>
                  <SaveButton
                    children="ทำแบบประเมินใหม่"
                    icon="reload"
                    style={{
                      marginRight: 10,
                      marginBottom: 10,
                      minWidth: 200,
                    }}
                    onClick={() => {
                      location.reload()
                    }}
                  />
                  {/* <CancelButton
                children="ปิดหน้าต่างนี้"
                style={{
                  marginRight: 10,
                  marginBottom: 10,
                  minWidth: 200,
                }}
                onClick={() => {
                  window.location.href = 'about:blank'
                  // window.close()
                }}
              /> */}
                </Row>
              </div>
            </Panel>
          ) : (
            <>
              {isView ? (
                <PrePostTestView schema={schema} />
              ) : (
                <>
                  <Panel
                    bordered
                    collapsible
                    defaultExpanded
                    shaded
                    style={{ marginBottom: 120, marginTop: 10 }}
                    header={schema.header}
                  >
                    {isPreView && (
                      <div style={{ marginBottom: 10 }}>
                        <div style={{ marginBottom: 10 }}>
                          <b>Link แบบประเมิน : </b>
                          <a
                            href={`${process.env.REACT_APP_SERVER_URL}${pathname.assessment.assessmentPrePostTest}?assId=${schema.assessmentId}`}
                            target="_blank"
                          >
                            {`${process.env.REACT_APP_SERVER_URL}${pathname.assessment.assessmentPrePostTest}?assId=${schema.assessmentId}`}
                          </a>
                        </div>
                        <ViewButton
                          icon="copy"
                          children="คัดลอก Link แบบประเมิน"
                          onClick={() => {
                            navigator.clipboard
                              .writeText(
                                `${process.env.REACT_APP_SERVER_URL}${pathname.assessment.assessmentPrePostTest}?assId=${schema.assessmentId}`
                              )
                              .then(() =>
                                notification.open('success', {
                                  title: 'คัดลอกเรียบร้อย',
                                  duration: 5000,
                                })
                              )
                              .catch((err) =>
                                notification.open('error', {
                                  title: 'คัดลอกไม่สำเร็จ',
                                  duration: 5000,
                                })
                              )
                          }}
                        />
                      </div>
                    )}

                    <Row style={{ marginBottom: 20 }}>
                      <Col lg={24} md={24} sm={24} xs={24}>
                        <InputForm
                          schema={schema.email}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                        />
                      </Col>
                      <Col lg={24} md={24} sm={24} xs={24}>
                        <InputForm
                          schema={schema.name}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                        />
                      </Col>
                      <Col lg={24} md={24} sm={24} xs={24}>
                        <InputForm
                          schema={schema.projectCode}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                        />
                      </Col>
                    </Row>

                    {/* {renderAssessment(schema.assessments || [], false)} */}
                    <Row style={{ marginTop: 10 }}>
                      <RenderAssessmentForm
                        assessments={schema.assessments || []}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        setAssessmentResult={setResult}
                      />
                    </Row>
                    {/* <div style={{ height: 80 }}></div> */}
                  </Panel>
                </>
              )}

              {!isPreView && !isView && (
                <div
                  style={{
                    zIndex: 998,
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: '#f4f9ff',
                    borderRadius: 5,
                    textAlign: 'center',
                  }}
                >
                  <div style={{ paddingBottom: 10 }}>
                    <div style={{ marginTop: 10, marginBottom: 10 }}>
                      <b>
                        <label
                          style={{
                            color:
                              (result?.size || 0) == schema.totalAssessment ? '#2da888' : '#fb8a81',
                          }}
                        >
                          <h4>
                            {result?.size || 0} / {schema.totalAssessment}
                          </h4>
                        </label>
                      </b>
                    </div>
                    <div>
                      <SaveButton children="บันทึก" onClick={handleSubmit(onSave)} />
                      <CancelButton
                        children="ยกเลิก"
                        onClick={onRefash}
                        // onClick={() => {
                        //   location.reload()
                        // }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}

      <ConfirmWidget
        title={`ยืนยัน`}
        show={isShowConfim}
        detail={`กรุณายืนยันการบันทึก`}
        onCancle={() => setIsShowConfim(false)}
        onConfirm={handleSubmit(onSubmit)}
      />
    </>
  )
}
